import { TO_NODE_TYPE } from './consts.js';
import { fromTypeMapper } from './fromTypeMapper.js';
import { Node_Type } from 'ricos-schema';
import { fromExternalNode } from './fromExternalNode.js';
import 'wix-rich-content-common';
import 'react';
import 'ricos-content/libs/convertNodeDataToDraftNoInnerRCE';
import 'lodash';
import '../../../../getClassNames-78fe1370.js';
import 'classnames';
import '../../utils/Anchorable.js';
import './ContainerElement.js';
import '../../utils/paywallSeo.js';
import 'ricos-context';
import 'ricos-content/libs/struct-converters';
import './nodeViewContainer.js';
import '../../../components/ErrorBoundary.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const SPECIAL_CONVERTERS = {
  [Node_Type.EXTERNAL]: fromExternalNode
};
const getPluginRenderers = (context, typeMappers, nodeViewRenderers, SpoilerViewerWrapper) => {
  const convertedTypeMappers = Object.entries(typeMappers).reduce(
    // @ts-ignore
    (renderers, [type, pluginComponent]) => {
      var _a, _b;
      return __spreadValues(__spreadValues(__spreadValues({}, renderers), (_a = SPECIAL_CONVERTERS[type]) == null ? void 0 : _a.call(SPECIAL_CONVERTERS, { pluginComponent, type, context, SpoilerViewerWrapper })), (_b = TO_NODE_TYPE[type]) == null ? void 0 : _b.reduce((renderers2, nodeType) => {
        return __spreadProps(__spreadValues({}, renderers2), {
          [nodeType]: fromTypeMapper({
            pluginComponent,
            type,
            context,
            SpoilerViewerWrapper
          })
        });
      }, {}));
    },
    {}
  );
  return __spreadValues(__spreadValues({}, convertedTypeMappers), nodeViewRenderers);
};

export { SPECIAL_CONVERTERS, getPluginRenderers };
//# sourceMappingURL=getPluginRenderers.js.map
